// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__oQ45H","menu_item":"style_menu_item__Q49_V","description":"style_description__3G9Sx","btn_logout":"style_btn_logout__1zdUw","active":"style_active__1m76V"};